// extracted by mini-css-extract-plugin
export default {"commentWrap":"commentWrap_XHlQC","action":"action_uhpXx","content":"content_IIS5p","link":"link_WnB1M","hoverable":"hoverable_xZtmV","feedback":"feedback_GNiDe","from":"from_JKoCO"};